import { render, staticRenderFns } from "./GroupSelectInput.vue?vue&type=template&id=8f889c4c"
import script from "./GroupSelectInput.vue?vue&type=script&lang=js"
export * from "./GroupSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports